import dayjs from 'dayjs'

import { ChecklistRightsEntities, ChecklistTask, ChecklistTaskComment } from '@/project/checklist/types'

import { ISOToYYYYMMDD } from './dates'
import { sanitizeString } from './strings'

export function doesTaskTitleMatchSearchQuery(searchQuery: Array<string>, title: string) {
  return searchQuery.some(searchQueryWord => title.toLowerCase().includes(searchQueryWord.toLowerCase()))
}

export function doesTaskCommentMatchSearchQuery (searchQuery: Array<string>, comment: ChecklistTaskComment) {
  return searchQuery.some(
    searchQueryWord => sanitizeString(comment.message.toLowerCase()).includes(searchQueryWord.toLowerCase()),
  )
}

export function doesTaskResponsiblesMatchSearchQuery(searchQuery: Array<string>, responsibles: ChecklistRightsEntities) {
  return searchQuery.some(
    searchQueryWord =>
      responsibles.users.some(user => user.fullName.toLowerCase().includes(searchQueryWord)) ||
      responsibles.groups.some(group => group.name.toLowerCase().includes(searchQueryWord)),
  )
}

export function doesTaskValidatorsMatchSearchQuery(searchQuery: Array<string>, validators: ChecklistRightsEntities) {
  return searchQuery.some(
    searchQueryWord =>
      validators.users.some(user => user.fullName.toLowerCase().includes(searchQueryWord)) ||
      validators.groups.some(group => group.name.toLowerCase().includes(searchQueryWord)),
  )
}

export function doesTaskMatchDueDateFilter (task: ChecklistTask, { value: filterValue }: DateFilter) {
  const filterFrom = filterValue.key[0]
  const filterTo = filterValue.key[1]

  if (filterTo) {
    return dayjs(ISOToYYYYMMDD(task.dueDate)).isAfter(dayjs(ISOToYYYYMMDD(filterFrom)))
      && dayjs(ISOToYYYYMMDD(task.dueDate)).isBefore(dayjs(ISOToYYYYMMDD(filterTo)))
  }

  return dayjs(ISOToYYYYMMDD(task.dueDate)).isAfter(dayjs(ISOToYYYYMMDD(filterFrom)))
}

export function doesTaskMatchResponsibleFilter (task: ChecklistTask, { value: filterValue }: Filter) {
  const responsibleFilterValue = (filterValue.key as string).split('-')

  if (responsibleFilterValue[0] === 'user') {
    return task.rights.responsibles.users.some(user => user.id === Number(responsibleFilterValue[1]))
  } else if (responsibleFilterValue[0] === 'group') {
    return task.rights.responsibles.groups.some(group => group.id === Number(responsibleFilterValue[1]))
  }

  return false
}

export function doesTaskMatchValidatorFilter (task: ChecklistTask, { value: filterValue }: Filter) {
  const validatorFilterValue = (filterValue.key as string).split('-')

  if (validatorFilterValue[0] === 'user') {
    return task.rights.validators.users.some(user => user.id === Number(validatorFilterValue[1]))
  } else if (validatorFilterValue[0] === 'group') {
    return task.rights.validators.groups.some(group => group.id === Number(validatorFilterValue[1]))
  }

  return false
}

export function doesTaskMatchStatusFilter (task: ChecklistTask, { value: filterValue }: Filter) {
  return task.status.id === filterValue.key
}
